var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.762 4.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M.793 0h.596a.794.794 0 0 1 .793.794v.595a.794.794 0 0 1-.793.794H.793A.794.794 0 0 1 0 1.389V.794A.794.794 0 0 1 .793 0m2.58 0h.595a.794.794 0 0 1 .794.794v.595a.794.794 0 0 1-.794.794h-.595a.794.794 0 0 1-.794-.794V.794A.794.794 0 0 1 3.373 0M.793 2.58h.596a.794.794 0 0 1 .793.793v.596a.794.794 0 0 1-.793.793H.793A.794.794 0 0 1 0 3.97v-.596a.794.794 0 0 1 .793-.793m2.58 0h.595a.794.794 0 0 1 .794.793v.596a.794.794 0 0 1-.794.793h-.595a.794.794 0 0 1-.794-.793v-.596a.794.794 0 0 1 .794-.793",
    style: {
      strokeWidth: 0.26458,
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.40eb236169e92ca2bf94db40bab6b000.svg";
export { ForwardRef as ReactComponent };